<template>
	<div class="modal fade" role="dialog" :aria-labelledby="ariaLabelled" aria-hidden="true" tabindex="-1">
		<div class="modal-dialog" role="document" :class="{'modal-lg': wideModal}">
			<div class="modal-content">

				<div class="modal-section" v-if="withSidebar">
					<slot name="sidebar"></slot>
				</div>

				<div class="modal-section">
					<div class="modal-header">
						<button type="button" class="close" aria-label="Close" data-dismiss="modal" data-testid="closeButton">
							<span aria-hidden="true">&times;</span>
						</button>
						<h5 class="modal-title" :id="ariaLabelled">
							<slot name="title"></slot>
						</h5>
					</div>
					<div class="modal-body" v-if="hasContent">
						<div>
							<div class="m-b-2">
								<slot></slot>
							</div>
						</div>
					</div>
					<div class="modal-footer" :class="{ 'text-xs-center' : centerButtons }">
						<slot name="footer">
							<button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
						</slot>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
import { defineComponent } from 'vue';
export default defineComponent({
	name: 'Modal',
	props: {
		centerButtons: {
			type: Boolean,
			default: false
		},
		ariaLabelled: {
			type: String,
			default: 'modalTitle'
		},
		wideModal: {
			type: Boolean,
			default: false
		},
		withSidebar: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		hasContent() {
			return this.content || this.$slots.default;
		}
	},
	destroyed() {
		$(this.$el).modal('dispose'); // TODO: Replace jQuery
	},
	methods: {
		show() {
			$(this.$el).modal('show'); // TODO: Replace jQuery
		},
		hide() {
			$(this.$el).modal('hide'); // TODO: Replace jQuery
		}
	}
});
</script>

<style scoped lang="scss">
.modal-content {
	display: flex;
	flex-wrap: wrap;
}
.modal-section {
	flex: 1 0 100%;
	display: flex;
	flex-direction: column;
}
@include media-breakpoint-up(md) {
	.modal-section {
		flex: 1 0 50%;
	}
}
.modal-header {
	min-height: 4rem;
	padding-right: 3.5rem;
}
.close {
	position: absolute;
	top: 1.5rem;
	right: 1.5rem;
}
.modal-body {
	flex-grow: 1;
}
// Remove space caused by empty header when "sidebar" section (above) at mobile breakpoints
@include media-breakpoint-down(sm) {
	.modal-section ~ .modal-section {
		.modal-header {
			padding-bottom: 0;
			min-height: 0;
		}
	}
}
</style>
